import employeeStatuses from 'modules/core/components/EmployeeMultiFilters/hooks/utils/employeeStatuses'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'

import type { CustomFilter } from 'modules/shift_management/hooks/reducers/filter'
import {
  SHIFT_CONFLICTS,
  SHIFT_WITHOUT_CONFLICTS,
} from 'modules/shift_management/hooks/reducers/filter'

export function getCustomFilters(filters: MultiFilterForm[]) {
  return filters.filter(
    (filter) => filter.get('custom_action').value && filter.get('field').value !== 'status'
  )
}

export function isStatusConflict(filters: MultiFilterForm[]) {
  return filters.some(
    (filter) =>
      filter.get('field').value === 'status' && filter.get('value').value === SHIFT_CONFLICTS
  )
}

export function isStatusWithoutConflict(filters: MultiFilterForm[]) {
  return filters.some(
    (filter) =>
      filter.get('field').value === 'status' &&
      filter.get('value').value === SHIFT_WITHOUT_CONFLICTS
  )
}

export function isPastEmployees(filters: MultiFilterForm[]) {
  return filters.some((filter) => {
    return (
      filter.get('field').value === 'employee_status' &&
      filter.get('value').value === employeeStatuses.terminated
    )
  })
}

export function formatCustomFilters(filters: MultiFilterForm[]) {
  return filters.map(
    (filter) =>
      ({
        field: filter.get('field').value,
        value: filter.get('value').value,
        condition: filter.get('condition').value,
      } as CustomFilter)
  )
}
